import http from '../axios.ts'
import {sha256} from "js-sha256";

const api = {
    /**
     * 更新尊盾数据
     * @param params
     */
    getZunTrustGoodsList(params:Object) {
        const res = http.post('/sslGoods/getZunTrustGoodsList', params);
        // console.log(res);
        return res;
    },

    /**
     * 分组查询所有的品牌
     * @param params
     */
    getSslBrand(params:Object) {
        const res = http.post('/sslGoods/getSslBrand', params);
        // console.log(res);
        return res;
    },

    /**
     * 分页查询SSL证书商品
     * @param params
     */
    getAllByPage(params:Object) {
        const res = http.post('/sslGoods/getAllByPage', params);
        // console.log(res);
        return res;
    },

    /**
     * 查看详情
     * @param params
     */
    getInfoById(params:Object) {
        const res = http.post('/sslGoods/getInfoById', params);
        // console.log(res);
        return res;
    },

    /**
     * 修改
     * @param params
     */
    update(params:Object) {
        const res = http.post('/sslGoods/update', params);
        // console.log(res);
        return res;
    },

    /**
     * 获取所有证书商品列表
     * @param params
     */
    getAll(params:Object) {
        const res = http.post('/sslGoods/getAll', params);
        // console.log(res);
        return res;
    },

    /**
     * 新增
     * @param params
     */
    add(params:Object) {
        const res = http.post('/sslGoods/add', params);
        // console.log(res);
        return res;
    }
}


export default api
